<script lang="ts">
	//Helpers
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import VirtualDeviceDrawerV2 from '../VirtualDeviceDrawerV2.svelte';
	import { status_configurator } from 'src/helpers/device_data_helpers';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VirtualDeviceTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_types';

	export let device: Device;
	export let virtualTemplate: VirtualDeviceTemplate;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: statuses = status_configurator(status, device);
</script>

<DeviceViewStateWrapper {device}>
	<div slot="content" class="flex-full-height justify-content-start">
		<VirtualDeviceDrawerV2 {device} {statuses} {virtualTemplate} />
	</div>
</DeviceViewStateWrapper>
